export class ConditionUnitRangeModel {
    public conditionUnitRangeId: number;
    public userConditionTypeId: number;
    public genderTypeId: number;
    public minValue: string;
    public maxValue: string;
    public minAge: number;
    public maxAge: number;
    public conditionUnitType: number;
}